Ext.define('SA.view.SearchField', {
    alias: 'widget.sa-search-field',
    extend: 'SA.view.TextField2',
    mixins: ['SA.view.mixin.ChildItems', 'Ext.Queryable'],

    clearButton: true,
    icon: true,

    buttons: {
        'sa-search-field-recent': 'onRecentClick',
        'sa-search-field-favorites': 'onFavoritesClick',
        'sa-text-field-clear': 'onClearClick'
    },

    renderTpl: (function() {
        var tpl = SA.view.TextField2.prototype.renderTpl.slice();

        tpl.push(
            '<button class="sa-text-field-button sa-search-field-recent"><svg aria-hidden="true" class="sa-text-field-svg"><use href="#sa-icon-recent"></use></svg></button>',
            '<button class="sa-text-field-button sa-search-field-favorites"><svg aria-hidden="true" class="sa-text-field-svg"><use href="#sa-icon-favorites"></use></svg></button>'
        );

        return tpl;
    })(),

    afterRender() {
        var el = this.el;

        this.callParent();

        this.updateRecentVisibility();

        if (this.recentButtonTitle) {
            Ext.fly(el.query('.sa-search-field-recent')[0]).set({title: this.recentButtonTitle});
        }

        if (this.favoritesButtonTitle) {
            Ext.fly(el.query('.sa-search-field-favorites')[0]).set({title: SA.localize(this.favoritesButtonTitle)});
        }

        el.on('transitionend', this.refreshRecentListArrow, this);
    },

    getChildItems() {
        return [this.getRecentList(false)];
    },

    getRecentList(create) {
        var list = this.recentList;

        if (!list) {
            return null;
        }

        if (!list.isComponent) {
            if (create === false) {
                return null;
            }

            list = this.recentList = Ext.widget(Object.assign({
                pickerOwner: this,
                track: true
            }, list));

            list.on('select', this.onSelect, this);
        }

        return list;
    },

    hideRecentList() {
        var list = this.getRecentList(false);

        if (list) {
            list.hide();
        }
    },

    refreshRecentListArrow() {
        var recentList = this.getRecentList(false);

        if (recentList) {
            recentList.getPlugin('sa-arrow').refresh();
        }
    },

    onDestroy() {
        this.callParent();

        Ext.destroy(this.getRecentList(false));
    },

    onEscKeyPress(ev) {
        this.setValue('');
        ev.preventDefault();
    },

    onFavoritesClick() {
        this.showRecentList(true);
    },

    onRecentClick() {
        this.showRecentList(false);
    },

    onSelect(list, id) {
        this.setValue('');

        this.fireEvent('select', this, id);
    },

    resetValue() {
        this.setValue('');
    },

    setFilter(filter) {
        this.getRecentList().setFilter(filter);

        this.updateRecentVisibility();
    },

    setSelected(selected) {
        this.selected = selected;

        this.getRecentList().setSelected(selected);
    },

    showRecentList(favorites) {
        var icon = this.el.down(favorites ? '.sa-search-field-favorites' : '.sa-search-field-recent', true),
            list = this.getRecentList(),
            details;

        if (this.lastListType === favorites && list.wasRecentlyVisible()) {
            return;
        }

        Ext.fly(icon).addCls('sa-text-field-button-active');

        list.setWidth(this.getWidth());

        details = list[favorites ? 'favorites' : 'recent'];

        list.setSource(details.source);
        list.setTitle(SA.localize(details.title));

        list.on('view-metadata:click', this.hideRecentList, this, {single: true});

        list.on('hide', function() {
            Ext.fly(icon).removeCls('sa-text-field-button-active').el.focus();
        }, null, {single: true});

        this.lastListType = favorites;

        list.getPlugin('sa-arrow').setTarget(icon);

        list.showBy(this);
    },

    updateRecentVisibility() {
        var list = this.getRecentList(),
            listeners = [];

        if (!this.rendered) {
            return;
        }

        Ext.destroy(this.listeners);

        this.listeners = listeners;

        ['recent', 'favorites'].forEach(recent => {
            var details = list && list[recent],
                source = details && details.source,
                visible = source && !list.isEmpty(source) && !source.initialCachePending,
                buttonEl = this.el.down('.sa-search-field-' + recent, true);

            Ext.fly(buttonEl).ifCls(!visible, 'sa-text-field-button-hidden');

            if (source) {
                listeners.push(this.mon(source, 'change', this.updateRecentVisibility, this, {destroyable: true}));
            }
        });

        if (list && list.isEmpty(list.source)) {
            list.hide();
        }
    }
});
